import { render } from "./VXVerified.vue?vue&type=template&id=6887cbfc"
import script from "./VXVerified.vue?vue&type=script&lang=js"
export * from "./VXVerified.vue?vue&type=script&lang=js"

import "./VXVerified.vue?vue&type=style&index=0&id=6887cbfc&lang=css"

import exportComponent from "/tmp/build_1ea34a31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__